/**
 * Zuordnung der im Altclient verwendeten Syncfusion-Symbolklassen auf die
 * Font-Awesome-Klassen, die der neue Client lädt (Kit aus `index.html`).
 *
 * Der Altclient bezieht die Symbole aus der Syncfusion-Symbolschrift; ohne
 * Syncfusion existiert diese Schrift nicht mehr. Die Klassennamen selbst
 * (`e-icons`, `e-caret`, …) bleiben erhalten, weil übernommene CSS-Regeln auf
 * sie zugreifen — nur das Glyph kommt aus Font Awesome.
 */

export const syncfusionIconMap: Readonly<Record<string, string>> = {
  // Werkzeugleisten und Formulare
  'e-plus': 'fa-solid fa-plus',
  'e-refresh': 'fa-solid fa-arrows-rotate',
  'e-delete': 'fa-solid fa-trash',
  'e-settings': 'fa-solid fa-gear',
  'e-people': 'fa-solid fa-users',
  'e-clock': 'fa-solid fa-clock',
  'e-export-excel-2': 'fa-solid fa-file-excel',
  'e-search': 'fa-solid fa-magnifying-glass',
  'e-close': 'fa-solid fa-xmark',
  'e-icon-dlg-close': 'fa-solid fa-xmark',
  'e-check': 'fa-solid fa-check',
  'e-upload': 'fa-solid fa-cloud-arrow-up',

  // Operatoren der Grid-Filterzeile (IwmGridFilterRow)
  'e-filter': 'fa-solid fa-filter',
  'e-equalto': 'fa-solid fa-equals',
  'e-greater-than': 'fa-solid fa-greater-than',
  'e-less-than': 'fa-solid fa-less-than',
  'e-conditional-formatting-large': 'fa-solid fa-not-equal',
  'e-text-that-contains': 'fa-solid fa-asterisk',
  'e-arrow-right': 'fa-solid fa-arrow-right',
  'e-arrow-left': 'fa-solid fa-arrow-left',

  // Eingabefelder und Popups
  'e-date-icon': 'fa-solid fa-calendar-days',
  'e-ddl-icon': 'fa-solid fa-caret-down',
  'e-clear-icon': 'fa-solid fa-xmark',
  'e-prev': 'fa-solid fa-chevron-left',
  'e-next': 'fa-solid fa-chevron-right',

  // Seitenblätterung des Grids
  'e-first-page': 'fa-solid fa-angles-left',
  'e-prev-page': 'fa-solid fa-arrow-left',
  'e-next-page': 'fa-solid fa-arrow-right',
  'e-last-page': 'fa-solid fa-angles-right',

  // Sortierpfeile der Kopfzeile
  'e-icon-ascending': 'fa-solid fa-arrow-up-long',
  'e-icon-descending': 'fa-solid fa-arrow-down-long',
};

/**
 * Übersetzt eine Syncfusion-Symbolangabe in Font-Awesome-Klassen.
 *
 * - `"e-icons e-plus"` → `"fa-solid fa-plus"` (der Marker `e-icons` entfällt,
 *   die Komponenten setzen ihn selbst).
 * - Bereits Font-Awesome-basierte Angaben bleiben unverändert.
 * - Unbekannte Zusatzklassen wie `red` bleiben erhalten.
 */
export function resolveIconClass(iconCss: string | undefined): string | undefined {
  if (iconCss === undefined) return undefined;

  const tokens = iconCss.split(/\s+/).filter((token) => token !== '' && token !== 'e-icons');
  const resolved: string[] = [];

  for (const token of tokens) {
    const mapped = syncfusionIconMap[token];
    for (const part of (mapped ?? token).split(' ')) {
      if (!resolved.includes(part)) resolved.push(part);
    }
  }

  return resolved.length === 0 ? undefined : resolved.join(' ');
}
